import { observer } from 'mobx-react-lite'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import ButtonWithProgress from 'reusable/mui/progress-button/ButtonWithProgress'
import Tooltip from '@mui/material/Tooltip'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import RefreshIcon from '@mui/icons-material/Refresh'
import { useOAuthClientStore } from './OAuthClientStore'
import SkeletonLoader from 'reusable/mui/skeleton/SkeletonLoader'

interface OAuthConfigFieldProps {
   label: string
   value: string
   fieldName: string
   showRegenerateButton?: boolean
   loading?: boolean
}

export default observer(function OAuthConfigField({ label, value, fieldName, showRegenerateButton, loading }: OAuthConfigFieldProps) {
   const oAuthClientStore = useOAuthClientStore()

   return (
      <Box sx={{ mb: 2 }}>
         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Box sx={{ textAlign: 'left' }}>
               <SkeletonLoader loading={loading || false} width={120} height={20}>
                  <Typography variant="subtitle2">
                     {label}
                  </Typography>
               </SkeletonLoader>
            </Box>
            {showRegenerateButton && (
               <SkeletonLoader loading={loading || false} width={120} height={32}>
                  <ButtonWithProgress
                     variant="outlined"
                     size="small"
                     icon={<RefreshIcon />}
                     iconAndLoadingPosition="start"
                     onClick={oAuthClientStore.handleRegenerateSecret}
                     loading={oAuthClientStore.isRegenerating}
                  >
                     Regenerate
                  </ButtonWithProgress>
               </SkeletonLoader>
            )}
         </Box>
         <SkeletonLoader loading={loading || false} height={40}>
            <TextField
               fullWidth
               value={value}
               slotProps={{
                  input: {
                     readOnly: true,
                     endAdornment: (
                        <Tooltip title={oAuthClientStore.copiedField === fieldName ? 'Copied!' : 'Copy to clipboard'}>
                           <IconButton
                              onClick={oAuthClientStore.handleCopyToClipboard}
                              data-value={value}
                              data-field-name={fieldName}
                              size="small"
                              color={oAuthClientStore.copiedField === fieldName ? 'success' : 'default'}
                           >
                              <ContentCopyIcon fontSize="small" />
                           </IconButton>
                        </Tooltip>
                     ),
                  }
               }}
               variant="outlined"
               size="small"
            />
         </SkeletonLoader>
      </Box>
   )
})
